import { useState, useEffect } from 'react';
import './Admin.css';
import SerieModal from './SerieModal';
import CreatorModal from './CreatorModal';
import FileUpload from './FileUpload';

function AlbumManager()
{
  const token = localStorage.getItem('token');

  // Form dropdown data
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [creators, setCreators] = useState([]);
  // Modals
  const [showSerieModal, setShowSerieModal] = useState(false);
  const [showCreatorModal, setShowCreatorModal] = useState(false);
  // Form data
  const [formData, setFormData] = useState({
    serieId: '',
    titre: '',
    tome: '',
    type: 'album',
    categorieId: '',
    auteurIds: [],
    illustrateurIds: [],
    annee: '',
    nbPages: '',
    dossier: ''
  });
  const [pageFiles, setPageFiles] = useState([]);

  // Helper function - add before handleInputChange
  const generateSlug = (text) =>
  {
    return text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/[^a-zA-Z0-9\s-]/g, '') // Remove special chars
      .replace(/\s+/g, '-'); // Spaces to dashes
  };

  useEffect(() =>
  {
    fetchFormData();
  }, []);

  const fetchFormData = async () =>
  {
    try
    {
      const [categoriesRes, seriesRes, creatorsRes] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/api/library/categories`),
        fetch(`${process.env.REACT_APP_API_URL}/api/library/series`),
        fetch(`${process.env.REACT_APP_API_URL}/api/library/creators`)
      ]);

      setCategories(await categoriesRes.json());
      setSeries(await seriesRes.json());
      setCreators(await creatorsRes.json());
    } catch (err)
    {
      console.error('Error loading form data:', err);
    }
  };

  const handleInputChange = (e) =>
  {
    const { name, value } = e.target;
    // Auto-generate dossier from titre
    if (name === 'titre')
    {
      const tome = formData.tome || 'X';
      const slug = generateSlug(value)

      setFormData(prev => (
        {
          ...prev,
          [name]: value,
          dossier: `${tome}-${slug}`
        }
      ));
    }
    else if (name === 'tome')
    {
      const slug = generateSlug(formData.titre)
      setFormData(prev => ({
        ...prev,
        [name]: value,
        dossier: value ? `${value}-${slug}` : `X-${slug}`
      }));
    }
    else setFormData(prev => ({ ...prev, [name]: value }));
  };
  const handleMultiSelect = (e, field) =>
  {
    e.preventDefault();
    const clickedValue = e.target.value;

    setFormData(prev =>
    {
      const currentValues = prev[field];
      // Toggle: if already selected, remove it; otherwise add it
      const newValues = currentValues.includes(clickedValue)
        ? currentValues.filter(id => id !== clickedValue)
        : [...currentValues, clickedValue];

      return { ...prev, [field]: newValues };
    });
  };
  const handleFileChange = (e) =>
  {
    setPageFiles(Array.from(e.target.files));
  };
  const handleFilesReorder
   = (reorderedFile) =>
  {
    setPageFiles(reorderedFile);
  };
  const handleSerieSaved = (newSerie) =>
  {
    setSeries(prev => [...prev, newSerie]);
    setFormData(prev => ({ ...prev, serieId: newSerie.id }));
  };
  const handleCreatorSaved = (newCreator) =>
  {
    setCreators(prev => [...prev, newCreator]);
  };
  const handleSubmitAlbum = async (e) =>
  {
    e.preventDefault();
  console.log('Form data:', formData); // DEBUG
  console.log('Page files:', pageFiles); // DEBUG
    try
    {
      const formDataToSend = new FormData();

      Object.keys(formData).forEach(key =>
      {
        if (key === 'auteurIds' || key === 'illustrateurIds')
        {
          formDataToSend.append(key, JSON.stringify(formData[key]));
        } else
        {
          formDataToSend.append(key, formData[key]);
        }
      });

      pageFiles.forEach((file) =>
      {
        formDataToSend.append('pages', file);
      });

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/library/albums`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formDataToSend
      });

      if (response.ok)
      {
        const result = await response.json();
        alert(`Album créé avec ${result.uploadedPages} pages!`);
        setFormData({
          serieId: '', titre: '', tome: '', type: 'album',
          categorieId: '', auteurIds: [], illustrateurIds: [],
          annee: '', nbPages: '', dossier: ''
        });
        setPageFiles([]);
      } else
      {
        const error = await response.json();
        alert('Erreur: ' + error.message);
      }
    } catch (err)
    {
      console.error('Error creating album:', err);
      alert('Erreur réseau');
    }
  };

  return (
    <div className="admin-container">
      <h1>Album Management</h1>

      <section className="admin-section">
        <h2>Add New Album</h2>
        <form onSubmit={ handleSubmitAlbum } className="album-form">

          <div className="form-row">
            <label>Serie *</label>
            <div className="form-row-with-button">
              <select name="serieId" value={ formData.serieId } onChange={ handleInputChange } required>
                <option value="">-- Choisir une série --</option>
                { series.map(s => (
                  <option key={ s.id } value={ s.id }>
                    { s.parentId ? '↳ ' : '' }{ s.nom }
                  </option>
                )) }
              </select>
              <button type="button" onClick={ () => setShowSerieModal(true) } className="btn-add-quick">
                + Nouvelle
              </button>
            </div>
          </div>

          <div className="form-row">
            <label>Catégorie *</label>
            <select name="categorieId" value={ formData.categorieId } onChange={ handleInputChange } required>
              <option value="">-- Choisir --</option>
              { categories.map(c => (
                <option key={ c.id } value={ c.id }>{ c.nom }</option>
              )) }
            </select>
          </div>

          <div className="form-row">
            <label>Titre *</label>
            <input type="text" name="titre" value={ formData.titre } onChange={ handleInputChange } required />
          </div>

          <div className="form-row">
            <label>Tome</label>
            <input type="number" name="tome" value={ formData.tome } onChange={ handleInputChange } />
          </div>

          <div className="form-row">
            <label>Type *</label>
            <select name="type" value={ formData.type } onChange={ handleInputChange } required>
              <option value="album">Album</option>
              <option value="hs">Hors-Série</option>
              <option value="artbook">Artbook</option>
            </select>
          </div>

          <div className="form-row">
            <label>Auteur(s) *</label>
            <div className="form-row-with-button">
              <select 
                multiple 
                name="auteurIds" 
                value={ formData.auteurIds }
                onClick={ (e) => handleMultiSelect(e, 'auteurIds') } 
                required
              >
                { creators.map(c => (
                  <option key={ c.id } value={ c.id }>{ c.nom }</option>
                )) }
              </select>
              <button type="button" onClick={ () => setShowCreatorModal(true) } className="btn-add-quick">
                + Nouveau
              </button>
            </div>
          </div>

          <div className="form-row">
            <label>Illustrateur(s) *</label>
            <div className="form-row-with-button">
              <select 
                multiple 
                onClick={ (e) => handleMultiSelect(e, 'illustrateurIds') } 
                value={ formData.illustrateurIds }
                required
              >
                { creators.map(c => (
                  <option key={ c.id } value={ c.id }>{ c.nom }</option>
                )) }
              </select>
              <button type="button" onClick={ () => setShowCreatorModal(true) } className="btn-add-quick">
                + Nouveau
              </button>
            </div>
          </div>

          <div className="form-row">
            <label>Année</label>
            <input type="number" name="annee" value={ formData.annee } onChange={ handleInputChange } />
          </div>

          <div className="form-row">
            <label>Nombre de pages</label>
            <input type="number" name="nbPages" value={ formData.nbPages } onChange={ handleInputChange } />
          </div>

          <div className="form-row">
            <label>Dossier *</label>
            <input type="text" name="dossier" value={ formData.dossier } readOnly onChange={ handleInputChange }
              placeholder="1-Quelque-part-entre-les-ombres" required />
          </div>

          <div className="form-row">
            <label>Pages (images) *</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={ handleFileChange }
            />
            <FileUpload files={pageFiles} onChange={handleFilesReorder} />
          </div>

          <button type="submit" className="btn-submit">Créer l'album</button>
        </form>
      </section>

      { showSerieModal && (
        <SerieModal
          parentSeries={ series }
          onClose={ () => setShowSerieModal(false) }
          onSave={ handleSerieSaved }
          token={ token }
        />
      ) }

      { showCreatorModal && (
        <CreatorModal
          onClose={ () => setShowCreatorModal(false) }
          onSave={ handleCreatorSaved }
          token={ token }
        />
      ) }
    </div>
  );
}

export default AlbumManager;